"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Files;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = require("FileManagerCore/actions/ActionTypes");

var _Constants = require("FileManagerCore/Constants");

var defaultState = _immutable.default.Map({
  objects: new _immutable.default.List(),
  total: 0,
  query: null,
  status: _Constants.RequestStatus.UNINITIALIZED,
  videoPlayerRequestStatus: _Constants.RequestStatus.UNINITIALIZED
});

function findIndex(state, fileId) {
  return state.get('objects').findIndex(function (item) {
    return item.get('id') === fileId;
  });
}

function replaceFile(state, file) {
  var index = findIndex(state, file.get('id'));

  if (index === -1) {
    return state;
  }

  return state.setIn(['objects', index], file);
}

function updateFile(state, fileId, updates) {
  var index = findIndex(state, fileId);

  if (index === -1) {
    return state;
  }

  var file = state.getIn(['objects', index]);
  file = file.merge(updates);
  return state.setIn(['objects', index], file);
}

function removeFile(state, fileId) {
  var index = findIndex(state, fileId);
  var objects = state.get('objects');
  return state.merge({
    objects: objects.delete(index),
    total: state.get('total') - 1
  });
}

function removeAll(state, files) {
  var nextState = state;
  files.forEach(function (file) {
    nextState = removeFile(nextState, file.get('id'));
  });
  return nextState;
}

function addAll(state, files) {
  if (files.count() === 0) {
    return state;
  }

  return state.merge({
    objects: state.get('objects').concat(files),
    total: state.get('total') + files.count()
  });
}

function Files() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      status = action.status,
      query = action.query,
      data = action.data,
      file = action.file,
      files = action.files,
      fileId = action.fileId,
      tempFile = action.tempFile,
      tempUrl = action.tempUrl,
      progress = action.progress,
      dimensions = action.dimensions;

  switch (type) {
    case _ActionTypes.FETCH_FILES_ATTEMPTED:
    case _ActionTypes.FETCH_FILES_FAILED:
      return state.merge({
        objects: new _immutable.default.List(),
        total: 0,
        query: query,
        status: status
      });

    case _ActionTypes.FETCH_FILES_SUCCEEDED:
      return state.merge({
        objects: data.get('objects'),
        total: data.get('total_count'),
        query: query,
        status: status
      });

    case _ActionTypes.FETCH_MORE_FILES_SUCCEEDED:
      return state.merge({
        objects: state.get('objects').concat(data.get('objects')),
        total: data.get('total_count')
      });

    case _ActionTypes.DOWNLOAD_FROM_DRIVE_SUCCEEDED:
    case _ActionTypes.DOWNLOAD_FROM_CANVA_SUCCEEDED:
    case _ActionTypes.DOWNLOAD_FROM_DROPBOX_SUCCEEDED:
    case _ActionTypes.UPLOAD_FILE_SUCCEEDED:
    case _ActionTypes.SAVE_EDIT_SUCCEEDED:
    case _ActionTypes.UPLOAD_EDITED_IMAGE_SUCCEEDED:
      return state.merge({
        objects: state.get('objects').unshift(file),
        total: state.get('total') + 1
      });

    case _ActionTypes.REPLACE_FILE_PROGRESS:
      return updateFile(state, fileId, {
        progress: progress
      });

    case _ActionTypes.REPLACE_FILE_ATTEMPTED:
      return updateFile(state, fileId, (0, _extends2.default)({
        replaced: true,
        size: tempFile.size,
        tempUrl: tempUrl,
        progress: progress
      }, dimensions));

    case _ActionTypes.MOVE_FILE_SUCCEEDED:
      if (state.hasIn(['query', 'folder_id'])) {
        return removeFile(state, data.get('id'));
      }

      return replaceFile(state, data);

    case _ActionTypes.DELETE_FILE_SUCCEEDED:
      return removeFile(state, fileId);

    case _ActionTypes.REPLACE_FILE_SUCCEEDED:
    case _ActionTypes.REPLACE_FILE_FAILED:
      return replaceFile(state, file);

    case _ActionTypes.RENAME_FILE_ATTEMPTED:
    case _ActionTypes.RENAME_FILE_SUCCEEDED:
    case _ActionTypes.RENAME_FILE_FAILED:
      return replaceFile(state, data);

    case _ActionTypes.ARCHIVE_FILE_SUCCEEDED:
    case _ActionTypes.UNARCHIVE_FILE_SUCCEEDED:
      return removeFile(state, data.get('id'));

    case _ActionTypes.BULK_DELETE_ATTEMPTED:
    case _ActionTypes.BULK_MOVE_ATTEMPTED:
      return removeAll(state, files);

    case _ActionTypes.BULK_DELETE_FAILED:
    case _ActionTypes.BULK_MOVE_FAILED:
      return addAll(state, files);

    case _ActionTypes.CREATE_VIDYARD_PLAYERID_ATTEMPTED:
      return state.merge({
        videoPlayerRequestStatus: _Constants.RequestStatus.PENDING
      });

    case _ActionTypes.CREATE_VIDYARD_PLAYERID_SUCCEEDED:
    case _ActionTypes.SOFT_DELETE_VIDYARD_PLAYERID_SUCCEEDED:
      return replaceFile(state, file).merge({
        videoPlayerRequestStatus: _Constants.RequestStatus.SUCCEEDED
      });

    case _ActionTypes.CREATE_VIDYARD_PLAYERID_FAILED:
    case _ActionTypes.SOFT_DELETE_VIDYARD_PLAYERID_FAILED:
      return state.merge({
        videoPlayerRequestStatus: _Constants.RequestStatus.FAILED
      });

    case _ActionTypes.SELECT_FILE:
      return state.merge({
        videoPlayerRequestStatus: _Constants.RequestStatus.UNINITIALIZED
      });

    case _ActionTypes.VIDEO_THUMBNAIL_UPDATE_SUCCEEDED:
    case _ActionTypes.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_SUCCEEDED:
      return replaceFile(state, file);

    default:
      return state;
  }
}

module.exports = exports.default;